var detectBrowser = require('./lib/detectBrowser');

module.exports = detectBrowser(navigator.userAgent);



/*****************
 ** WEBPACK FOOTER
 ** ./~/detect-browser/browser.js
 ** module id = 94
 ** module chunks = 0
 **/